import { ArrayUtils } from "../../ArrayUtils";
const POSITION = "position";
export class CoreGeometryIndexBuilder {
  static createIndexIfNone(geometry) {
    if (!geometry.index) {
      const position = geometry.getAttribute(POSITION);
      if (position) {
        const position_array = position.array;
        geometry.setIndex(ArrayUtils.range(position_array.length / 3));
      }
    }
  }
}
